import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export const deleteDrtIntegration = async (id: string): Promise<void> => {
  await baseAPI.delete(`/api/admin/drt/integrations/${id}`);
};

export const useDeleteDrtIntegration = () => {
  return useMutation({
    mutationFn: deleteDrtIntegration,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.DRT_INTEGRATIONS],
      });
    },
  });
};
